"use strict";

import React, { Component, PropTypes } from 'react';
import { Modal, Button } from 'react-bootstrap';
import OneToOneForm from './oneToOneForm';

import { AccountActions, SessionActions, AlertActions } from '../../../actions';

class OneToOne extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canSubmit: false,
    };
    this._handleSubmit = this._handleSubmit.bind(this);
    this._onFormValid = this._onFormValid.bind(this);
  };

  static propTypes = {
    open: PropTypes.bool.isRequired
  };
  render() {
    return (
      <Modal show={this.props.open} >
        <Modal.Header closeButton>
          <Modal.Title>One To One Conference Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OneToOneForm selectedMentor={this.props.selectedMentor} ref="form" isValid={this._onFormValid} />
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button bsStyle="primary" disabled={!this.state.canSubmit} onClick={(e) => {
              this._handleSubmit(e);
            }} >Submit</Button>
            <Button className="m-l-5p" type="submit" bsStyle="default" onClick={() => {
              this.props.onClose();
            }}>Cancel</Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  };

  _handleSubmit(e) {
    e.preventDefault();
    const payload = this.refs.form.getModel();
    this.props.onSubmit(payload);
    this.props.onClose();
  };

  _onFormValid(isValid) {
    this.setState({ canSubmit: isValid });
  };


}

export default OneToOne;
